var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"action",attrs:{"type":"button"}},_vm.$listeners),[_c('AppTrashIcon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }